import React from 'react';
import { Redirect } from 'react-router-dom';
import { isAuthenticated } from './auth';

const RedireccionarMenu = () => {
  return isAuthenticated() ? <Redirect to="/" /> : <Redirect to="/login" />;
};

export default RedireccionarMenu;